import React, { useEffect, useRef, useContext } from 'react'
import { useSelector } from 'react-redux'
import PageContext from '@contexts/pageContext'

import { useOutsideClick, useSetState } from '@campaignhub/react-hooks'
import { Box, FormField, Text } from '@campaignhub/suit-theme'

import custom from '@styles/custom.module.scss'

const defaultState = {
  showFilter: false,
}

const RoleFilter = () => {
  const [state, setState] = useSetState(defaultState)
  const { showFilter } = state

  const { result: userRolesV4 } = useSelector(reduxState => reduxState.userRolesV4)
  const { callbacks: { toggleSelectedRole }, selectedRole } = useContext(PageContext)

  const contentEl = useRef()
  const [isClickedOutside, setIsClickedOutside] = useOutsideClick(contentEl, { enabled: showFilter })

  useEffect(() => {
    if (isClickedOutside && showFilter) {
      setState({ showFilter: !showFilter })
      setIsClickedOutside(false)
    }
  }, [isClickedOutside])

  return (
    <FormField direction="column" boxProps={{ paddingBottom: 'medium' }}>
      <Box className={custom.root} ref={contentEl}>
        <select
          onMouseDown={(e) => {
            e.preventDefault()
            setState({ showFilter: !showFilter })
          }}
          value="Roles"
        >
          <option>Roles</option>
        </select>

        {showFilter && (
          <Box className={custom.popup}>
            <Box flexDirection="column" maxHeight="280px" overflowY="auto">
              {Object.values(userRolesV4)?.filter(x => !['Agent', 'Assistant', 'Client_Admin', 'Unknown'].includes(x?.value))?.map(role => (
                <Box flexDirection="row" paddingTop="small" paddingBottom="medium" alignItems="center">
                  <input
                    className={custom.checkbox}
                    onChange={e => toggleSelectedRole(e.target.checked, role.value)}
                    type="checkbox"
                    checked={selectedRole.includes(role.value)}
                  />
                  <Text fontSize="small" marginLeft="medium">{role.name}</Text>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </FormField>
  )
}

export default RoleFilter
